import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RotateIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Circular arrow for rotation */}
      <path
        d="M12 3a9 9 0 1 0 9 9"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
      />
      {/* Arrow head */}
      <path
        d="M17 3v5h5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M21 3l-4 5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
      />
    </BaseIcon>
  ),
);

RotateIcon.displayName = 'RotateIcon';
